import { render, staticRenderFns } from "./modalTariffUploadDetail.vue?vue&type=template&id=72a9aeec&scoped=true"
import script from "./modalTariffUploadDetail.vue?vue&type=script&lang=js"
export * from "./modalTariffUploadDetail.vue?vue&type=script&lang=js"
import style0 from "./modalTariffUploadDetail.vue?vue&type=style&index=0&id=72a9aeec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a9aeec",
  null
  
)

export default component.exports